import { FC } from 'react';

import LazyLoadImage from '../lazy-load-image/lazy-load-image';
import RoomstaySemHelpdeskForm from '../roomstay-blog-sem-helpdesk-form/roomstay-blog-sem-helpdesk-form';
import styles from './roomstay-blog-novacancy.module.scss';

export interface BlogNovacancyProps {
    welcomeMessage: string;
    time: string;
    location: string;
    description: string;
    image: string;
    titleForm: string;
    buttonText?: string;
}

const RoomstayBlogNovacancy: FC<BlogNovacancyProps> = (props) => {
    const { welcomeMessage, time, location, description, image, buttonText, titleForm } = props;

    return (
        <div className={styles.container}>
            <div className={styles.background}></div>
            <div className={styles.wrapper}>
                <div className={styles.content}>
                    <h1
                        className={styles.welcomeMessage}
                        dangerouslySetInnerHTML={{
                            __html: welcomeMessage || '',
                        }}
                    />
                    {image && <LazyLoadImage className={styles.image} imageUrl={image} />}
                    <div className={styles.timeLocation}>
                        <div
                            className={styles.time}
                            dangerouslySetInnerHTML={{
                                __html: time || '',
                            }}
                        />
                        <div
                            className={styles.location}
                            dangerouslySetInnerHTML={{
                                __html: location || '',
                            }}
                        />
                    </div>
                    <div className={styles.divider}/>
                    <div
                        className={styles.description}
                        dangerouslySetInnerHTML={{
                            __html: description || '',
                        }}
                    />
                </div>
                <div className={styles.wrapperForm}>
                    <RoomstaySemHelpdeskForm 
                        titleForm={titleForm} 
                        fontSizeTitle="default" 
                        buttonText={buttonText} 
                        theme="type_2" 
                    />
                </div>
            </div>
        </div>
    );
};

export default RoomstayBlogNovacancy;
